// @flow
import type {SsoUserCloseActivateUserModalAction, SsoUserOpenActivateUserModalAction} from "../ssoUserActivateUserAction";

/**
 * Created by Mike Chung on 2/13/18.
 */

export function openSsoUserActivateUserModalAction(ssoUid: string): SsoUserOpenActivateUserModalAction {
    return {
        type: "sso/SHOW_ACTIVATE_USER_MODAL_ACTION",
        ssoUid: "" + ssoUid
    }
}

export function closeSsoUserActivateUserModalAction(): SsoUserCloseActivateUserModalAction {
    return {
        type: "sso/HIDE_ACTIVATE_USER_MODAL_ACTION"
    }
}



// WEBPACK FOOTER //
// ./src/actions/modal/creators/ssoUserActivateUserActionCreator.js